if (!customElements.get('deployer-upsell')) {
  const quickAddModalOpen = (el) => {
    if (!el) return;
    el.removeAttribute('hidden');
  };

  const quickAddModalClose = (el) => {
    if (!el) return;
    el.setAttribute('hidden', '');
  };

  /* theme.classic.js skippe enableDynamicVariantOptions dans .featured-products__quick-add-modal */
  const applyDeployerQuickAddVariantIndicators = (form, variants) => {
    if (!form?.querySelector('.product__variant-select') || !variants.length) return;
    const optionNames = Object.keys(variants[0])
      .filter((k) => k.startsWith('option'))
      .sort();
    const pickers = [...form.querySelectorAll('.product__variant-select')];
    const cur = {};
    pickers.forEach((picker, i) => {
      const sel = picker.querySelector('select');
      const radios = picker.querySelectorAll('input[type="radio"]');
      const selectedSwatch = picker.querySelector('.product__color-swatch.selected, [data-product-swatch].selected');
      const v = selectedSwatch?.dataset?.label
        || (sel ? sel.value : [...radios].find((r) => r.checked)?.value);
      if (v) cur[optionNames[i]] = v;
    });
    const match = (variant, ts) => optionNames.every((k) => !ts[k] || variant[k] === ts[k]);

    pickers.forEach((picker, i) => {
      const key = optionNames[i];
      const select = picker.querySelector('select');
      const radios = picker.querySelectorAll('input[type="radio"]');
      const vals = select
        ? [...select.options].map((o) => o.value)
        : [...radios].map((r) => r.value);
      const hasSw = picker.querySelector('[data-product-swatch]');

      /* Si pas de select/radio (swatches seuls), prendre les labels des swatches */
      const values = vals.length
        ? vals
        : [...picker.querySelectorAll('[data-product-swatch]')].map((sw) => sw.dataset.label).filter(Boolean);

      values.forEach((val) => {
        const ts = { ...cur, [key]: val };
        const exists = variants.some((variant) => match(variant, ts));
        const ok = variants.some((variant) => match(variant, ts) && variant.available);

        if (!hasSw) {
          if (select) {
            const el = [...select.options].find((o) => o.value === val);
            if (el) {
              el.disabled = !ok;
              el.style.display = ok ? '' : 'none';
            }
          } else {
            const r = [...radios].find((x) => x.value === val);
            const lab = r && picker.querySelector(`label[for="${r.id}"]`);
            if (r) {
              r.disabled = !ok;
              if (lab) lab.style.display = ok ? '' : 'none';
            }
          }
        } else {
          if (select) {
            const el = [...select.options].find((o) => o.value === val);
            if (el) {
              el.disabled = false;
              el.style.display = '';
            }
          } else {
            const r = [...radios].find((x) => x.value === val);
            const lab = r && picker.querySelector(`label[for="${r.id}"]`);
            if (r) {
              r.disabled = false;
              if (lab) lab.style.display = '';
            }
          }
          picker.querySelectorAll('[data-product-swatch]').forEach((sw) => {
            if (sw.dataset.label !== val) return;
            if (!exists) {
              sw.style.display = 'none';
              sw.classList.remove('unavailable');
            } else {
              sw.style.display = '';
              sw.classList.toggle('unavailable', !ok);
            }
          });
        }
      });
    });
  };

  const waxVariantOptionLabel = (variant) => {
    const idStr = String(variant.id);
    if (variant.name && String(variant.name).trim() !== '') return String(variant.name).trim();
    const optionParts = [variant.option1, variant.option2, variant.option3].filter(
      (x) => x != null && String(x).trim() !== ''
    );
    if (optionParts.length) return optionParts.join(' · ');
    if (variant.title && variant.title !== 'Default Title') return String(variant.title);
    return idStr;
  };

  /* #wax-variants-select est rempli avec le produit de la page ; on le réécrit pour le produit du QuickAdd. */
  const syncWaxVariantSelectForUpsell = (variants, selectedVariantId) => {
    const select = document.getElementById('wax-variants-select');
    if (!select || selectedVariantId == null || Number.isNaN(Number(selectedVariantId))) return;
    if (!Array.isArray(variants) || !variants.length) return;

    const selectedStr = String(selectedVariantId);
    let oosVariants = variants.filter((v) => v.available === false);
    const selectedVariant = variants.find((v) => String(v.id) === selectedStr);
    if (selectedVariant && !oosVariants.some((v) => String(v.id) === selectedStr)) {
      oosVariants = oosVariants.concat([selectedVariant]);
    }
    if (oosVariants.length === 0) return;

    oosVariants.sort((a, b) => Number(a.id) - Number(b.id));
    select.innerHTML = '';
    for (const variant of oosVariants) {
      const opt = document.createElement('option');
      opt.value = String(variant.id);
      opt.textContent = waxVariantOptionLabel(variant);
      select.appendChild(opt);
    }

    if (Array.from(select.options).some((o) => o.value === selectedStr)) {
      select.value = selectedStr;
    } else {
      select.selectedIndex = 0;
    }

    const modal = document.querySelector('[id^="wax-back-in-stock-modal"]');
    if (modal) modal.dataset.variantId = select.value;
  };

  customElements.define(
    'deployer-upsell',
    class DeployerUpsell extends HTMLElement {
      #syncSelectChangeHandler = null;
      #syncFormChangeHandler = null;
      #syncMainProductForm = null;
      #syncVariantChangeDomHandler = null;
      #syncVariantPubSubHandler = null;
      #syncVariantUnsubscribe = null;
      #syncVariantIdControl = null;

      constructor() {
        super();
        this.cards = this.querySelectorAll('[data-product-card]');
        this.addToCartTextDesktop = this.dataset.addToCartTextDesktop || 'Ajouter au panier';
        this.addToCartTextMobile = this.dataset.addToCartTextMobile || 'Ajouter';
        this.soldOutText = this.dataset.soldOutText || 'Épuisé';
        this.preselectColorValue = (this.dataset.preselectColorValue || '').trim();
        this.syncProductVariant = this.dataset.syncProductVariant === 'true';
        this.mainProductColorOptionPosition = (this.dataset.mainProductColorOptionPosition || '').trim();
        this.blockId = this.dataset.blockId || '';
        this.quickAddModal = this.blockId ? document.getElementById(`modal-quick-add-deployer--${this.blockId}`) : null;
      }

      connectedCallback() {
        this.cards.forEach((card) => this.#bindCard(card));
        if (this.preselectColorValue) this.#applyPreselectColor();
        if (this.syncProductVariant && this.mainProductColorOptionPosition) this.#bindMainProductVariantSync();
      }

      disconnectedCallback() {
        this.#unbindMainProductVariantSync();
      }

      #getVariants(card) {
        const script = card.querySelector('[data-deployer-upsell-variants]');
        if (!script || !script.textContent) return [];
        try {
          return JSON.parse(script.textContent.trim());
        } catch {
          return [];
        }
      }

      #applyPreselectColor() {
        if (!this.preselectColorValue) return;

        const colors = this.preselectColorValue
          .split(',')
          .map((c) => c.trim())
          .filter(Boolean);

        if (colors.length === 0) return;

        // One color → all products; several → one per product in order
        if (colors.length === 1) {
          this.#applyColorValueToCards(colors[0]);
          return;
        }

        this.cards.forEach((card, index) => {
          const color = colors[index];
          if (!color) return;
          this.#applyColorValueToCard(card, color);
        });
      }

      #applyColorValueToCard(card, rawValue) {
        const value = (rawValue || '').toString().trim();
        if (!value) return;
        const normalized = value.toLowerCase();
        const select = card.querySelector('[data-product-card-select]');
        const variants = this.#getVariants(card);
        if (!select || variants.length === 0) return;
        const matches = variants.filter(
          (v) =>
            (v.option1 || '').toString().trim().toLowerCase() === normalized ||
            (v.option2 || '').toString().trim().toLowerCase() === normalized ||
            (v.option3 || '').toString().trim().toLowerCase() === normalized
        );
        const toSelect = matches.find((v) => v.available) || matches[0];
        if (toSelect && String(toSelect.id) !== select.value) {
          select.value = String(toSelect.id);
          select.dispatchEvent(new Event('change'));
          this.#syncAllDropdownsAndLabels(card, select);
        }
      }

      #applyColorValueToCards(rawValue) {
        const value = (rawValue || '').toString().trim();
        if (!value) return;
        this.cards.forEach((card) => this.#applyColorValueToCard(card, value));
      }

      #getMainProductForm() {
        return (
          document.querySelector('.product-form form[action*="/cart/add"]') ||
          document.querySelector('.product__page form[action*="/cart/add"]') ||
          document.querySelector('.product form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add.js"]') ||
          document.querySelector('form[action*="/cart/add"]')
        );
      }

      #parseMainProductVariantsJson() {
        const script = document.querySelector('script[data-product-variants]');
        if (!script || !script.textContent) return [];
        try {
          const parsed = JSON.parse(script.textContent.trim());
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [];
        }
      }

      #applyColorFromMainProductVariant(variant) {
        if (!variant) return;
        const pos = this.mainProductColorOptionPosition;
        const key = pos === '1' || pos === '2' || pos === '3' ? `option${pos}` : '';
        if (!key) return;
        const colorVal = (variant[key] || '').toString().trim();
        if (!colorVal) return;
        this.#applyColorValueToCards(colorVal);
      }

      #applyColorFromMainProductByCurrentFormVariant() {
        const form = this.#getMainProductForm();
        if (!form) return;
        const idControl = form.querySelector('select[name="id"], input[name="id"]');
        if (!idControl || !idControl.value) return;
        const variants = this.#parseMainProductVariantsJson();
        const variant = variants.find((v) => String(v.id) === String(idControl.value));
        this.#applyColorFromMainProductVariant(variant);
      }

      #bindMainProductVariantSync() {
        this.#unbindMainProductVariantSync();
        const form = this.#getMainProductForm();
        if (!form) return;

        this.#syncMainProductForm = form;
        this.#syncSelectChangeHandler = () => this.#applyColorFromMainProductByCurrentFormVariant();
        /* Product section dispatches a bubbling "change" on the form after updating the variant select (theme.classic.js). */
        this.#syncFormChangeHandler = () => this.#applyColorFromMainProductByCurrentFormVariant();
        /* enableDynamicVariantOptions dispatches option:change with detail.variant; variant:change is for other themes. */
        this.#syncVariantChangeDomHandler = (event) => {
          const variant = event?.detail?.variant;
          if (variant) this.#applyColorFromMainProductVariant(variant);
        };
        this.#syncVariantPubSubHandler = (event) => {
          const variant = event?.data?.variant;
          if (variant) this.#applyColorFromMainProductVariant(variant);
        };

        this.#syncVariantIdControl = form.querySelector('select[name="id"], input[name="id"]');
        if (this.#syncVariantIdControl) {
          this.#syncVariantIdControl.addEventListener('change', this.#syncSelectChangeHandler);
        }

        form.addEventListener('change', this.#syncFormChangeHandler);

        document.addEventListener('option:change', this.#syncVariantChangeDomHandler);
        document.addEventListener('variant:change', this.#syncVariantChangeDomHandler);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.#syncVariantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.#syncVariantPubSubHandler);
        }

        this.#applyColorFromMainProductByCurrentFormVariant();
      }

      #unbindMainProductVariantSync() {
        if (this.#syncVariantIdControl && this.#syncSelectChangeHandler) {
          this.#syncVariantIdControl.removeEventListener('change', this.#syncSelectChangeHandler);
        }
        this.#syncVariantIdControl = null;
        this.#syncSelectChangeHandler = null;

        if (this.#syncMainProductForm && this.#syncFormChangeHandler) {
          this.#syncMainProductForm.removeEventListener('change', this.#syncFormChangeHandler);
        }
        this.#syncMainProductForm = null;
        this.#syncFormChangeHandler = null;

        if (this.#syncVariantChangeDomHandler) {
          document.removeEventListener('option:change', this.#syncVariantChangeDomHandler);
          document.removeEventListener('variant:change', this.#syncVariantChangeDomHandler);
          this.#syncVariantChangeDomHandler = null;
        }

        if (typeof this.#syncVariantUnsubscribe === 'function') {
          this.#syncVariantUnsubscribe();
          this.#syncVariantUnsubscribe = null;
        }
        this.#syncVariantPubSubHandler = null;
      }

      #bindCard(card) {
        const quickAddTriggers = card.querySelectorAll('[data-deployer-quick-add-trigger]');
        if (quickAddTriggers.length > 0) {
          quickAddTriggers.forEach((trigger) => {
            trigger.addEventListener('click', (e) => {
              e.preventDefault();
              this.#openQuickAddModal(trigger);
            });
          });
          return;
        }

        const select = card.querySelector('[data-product-card-select]');
        const priceContainer = card.querySelector('[data-product-card-price]');
        const button = card.querySelector('[data-add-to-cart]');
        const buttonTextDesktop = button?.querySelector('[data-button-text-desktop]');
        const buttonTextMobile = button?.querySelector('[data-button-text-mobile]');
        const image = card.querySelector('[data-card-image]');
        const variants = this.#getVariants(card);

        if (select) {
          select.addEventListener('change', () => {
            this.#onVariantChange(card, select, priceContainer, button, buttonTextDesktop, buttonTextMobile, image);
            this.#syncAllDropdownsAndLabels(card, select);
          });
        }

        const dropdownTriggers = card.querySelectorAll('[data-deployer-upsell-dropdown-trigger]');
        dropdownTriggers.forEach((trigger) => {
          const optionPosition = trigger.dataset.optionPosition;
          const list = card.querySelector(`[data-deployer-upsell-dropdown-list][data-option-position="${optionPosition}"]`);
          if (list) this.#bindDropdown(card, trigger, list, select, variants);
        });

        this.#syncAllDropdownsAndLabels(card, select);

        if (button) {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            this.#handleAddToCart(button, card);
          });
        }
      }

      #bindDropdown(card, trigger, list, select, variants) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';
          card.querySelectorAll('[data-deployer-upsell-dropdown-list]').forEach((l) => l.classList.remove('is-open'));
          card.querySelectorAll('[data-deployer-upsell-dropdown-trigger]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
          trigger.setAttribute('aria-expanded', !isOpen);
          list.classList.toggle('is-open', !isOpen);
        });

        list.querySelectorAll('[data-option-position][data-value]').forEach((item) => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            const optionPosition = parseInt(item.dataset.optionPosition, 10);
            const value = item.dataset.value;

            const labelSpan = card.querySelector(`[data-option-selected][data-option-position="${optionPosition}"]`);
            if (labelSpan) labelSpan.textContent = value;

            const textEl = trigger.querySelector('.product-tile__dropdown-text');
            const swatchEl = trigger.querySelector('.product-tile__dropdown-swatch');
            if (textEl) textEl.textContent = value;
            if (swatchEl && item.querySelector('.product-tile__dropdown-item-swatch')) {
              const itemSwatch = item.querySelector('.product-tile__dropdown-item-swatch');
              swatchEl.style.cssText = itemSwatch.style.cssText || '';
            }

            trigger.setAttribute('aria-expanded', 'false');
            list.classList.remove('is-open');

            const selected = this.#getSelectedOptionsFromCard(card);
            const variant = this.#findVariantByOptions(variants, selected);
            if (variant && select) {
              select.value = String(variant.id);
              select.dispatchEvent(new Event('change'));
            }
          });
        });

        document.addEventListener('click', (e) => {
          if (!card.contains(e.target)) {
            card.querySelectorAll('[data-deployer-upsell-dropdown-list]').forEach((l) => l.classList.remove('is-open'));
            card.querySelectorAll('[data-deployer-upsell-dropdown-trigger]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
          }
        });
      }

      #getSelectedOptionsFromCard(card) {
        const selected = {};
        card.querySelectorAll('[data-deployer-upsell-dropdown-trigger]').forEach((trigger) => {
          const pos = trigger.dataset.optionPosition;
          const textEl = trigger.querySelector('.product-tile__dropdown-text');
          if (pos && textEl) selected[pos] = textEl.textContent.trim();
        });
        return selected;
      }

      #findVariantByOptions(variants, selected) {
        return variants.find((v) => {
          for (const pos of ['1', '2', '3']) {
            const sel = (selected[pos] || '').toString().trim();
            if (sel === '') continue;
            const opt = (v[`option${pos}`] || '').toString().trim();
            if (sel !== opt) return false;
          }
          return true;
        });
      }

      #syncAllDropdownsAndLabels(card, select) {
        if (!select) return;
        const option = select.options[select.selectedIndex];
        if (!option) return;
        const o1 = (option.dataset.option1 || '').trim();
        const o2 = (option.dataset.option2 || '').trim();
        const o3 = (option.dataset.option3 || '').trim();
        const valuesByPosition = { '1': o1, '2': o2, '3': o3 };

        card.querySelectorAll('[data-option-selected]').forEach((span) => {
          const pos = span.dataset.optionPosition;
          if (valuesByPosition[pos] !== undefined) span.textContent = valuesByPosition[pos];
        });

        card.querySelectorAll('[data-deployer-upsell-dropdown-trigger]').forEach((trigger) => {
          const pos = trigger.dataset.optionPosition;
          const value = valuesByPosition[pos];
          if (value === undefined) return;
          const textEl = trigger.querySelector('.product-tile__dropdown-text');
          if (textEl) textEl.textContent = value;
          const list = card.querySelector(`[data-deployer-upsell-dropdown-list][data-option-position="${pos}"]`);
          const items = list?.querySelectorAll('[data-value]') || [];
          const item = Array.from(items).find((i) => i.dataset.value === value);
          if (item && trigger.querySelector('.product-tile__dropdown-swatch') && item.querySelector('.product-tile__dropdown-item-swatch')) {
            const swatchEl = trigger.querySelector('.product-tile__dropdown-swatch');
            const itemSwatch = item.querySelector('.product-tile__dropdown-item-swatch');
            swatchEl.style.cssText = itemSwatch.style.cssText || '';
          }
        });
      }

      #onVariantChange(card, select, priceContainer, button, buttonTextDesktop, buttonTextMobile, image) {
        const option = select.options[select.selectedIndex];
        if (!option) return;

        const price = option.dataset.price;
        const compareAtPrice = option.dataset.compareAtPrice;
        const available = option.dataset.available === 'true';
        const variantId = option.value;
        const featuredImage = option.dataset.featuredImage;

        if (priceContainer) {
          const priceValue = parseInt(price, 10);
          const compareAtPriceValue = parseInt(compareAtPrice, 10) || 0;
          if (compareAtPriceValue > priceValue) {
            priceContainer.innerHTML = `<s>${formatPrice(compareAtPriceValue)}</s> <span>${formatPrice(priceValue)}</span>`;
          } else {
            priceContainer.innerHTML = `<span>${formatPrice(priceValue)}</span>`;
          }
        }

        if (button) {
          button.dataset.variantId = variantId;
          button.disabled = !available;
          const text = available ? this.addToCartTextDesktop : this.soldOutText;
          const textMobile = available ? this.addToCartTextMobile : this.soldOutText;
          if (buttonTextDesktop) buttonTextDesktop.textContent = text;
          if (buttonTextMobile) buttonTextMobile.textContent = textMobile;
        }

        if (image && featuredImage) {
          image.src = featuredImage;
        }
      }

      #openQuickAddModal(triggerButton) {
        if (!this.quickAddModal) return;
        const productUrl = triggerButton.dataset.productUrl;
        if (!productUrl) return;

        /* Move dialog to body so it is outside the product section DOM; theme code that scopes to the product section (e.g. section.querySelector("[data-product-form]")) will then only find the main page form, not the modal. */
        if (this.quickAddModal.parentNode !== document.body) {
          document.body.appendChild(this.quickAddModal);
        }

        const modalContent = this.quickAddModal.querySelector('.quick-add-modal-content');
        const closeBtn = this.quickAddModal.querySelector('.close-quick-add-modal');
        if (!modalContent) return;

        triggerButton.classList.add('loading');
        triggerButton.disabled = true;

        const origin = window.location.origin;
        const preferredVariantId = (triggerButton.dataset.variantId || '').trim();
        const url = new URL(productUrl.startsWith('http') ? productUrl : origin + productUrl);
        if (preferredVariantId) url.searchParams.set('variant', preferredVariantId);
        const productFullUrl = origin + (productUrl.startsWith('http') ? new URL(productUrl).pathname : productUrl.split('?')[0]);

        fetch(url.toString())
          .then((response) => response.text())
          .then((responseText) => {
            this.#processDeployerQuickAddContent(responseText, modalContent, productFullUrl, preferredVariantId);
            quickAddModalOpen(this.quickAddModal);

            if (closeBtn) {
              const onClose = () => {
                quickAddModalClose(this.quickAddModal);
                closeBtn.removeEventListener('click', onClose);
                this.quickAddModal.removeEventListener('click', onBackdropClose);
                document.removeEventListener('keydown', onEscape);
              };
              const onBackdropClose = (e) => {
                if (e.target.closest('[data-quick-add-modal-dismiss]')) onClose();
              };
              const onEscape = (e) => {
                if (e.key === 'Escape') onClose();
              };
              closeBtn.addEventListener('click', onClose);
              this.quickAddModal.addEventListener('click', onBackdropClose);
              document.addEventListener('keydown', onEscape);
            }

            /* Do NOT call registerProductSection: it would init the theme product Section in the modal and cause conflict with the real product page (URL changes, shared state). The modal is fully handled by #setupModalVariantSync. */
          })
          .catch((err) => {
            console.error('Deployer upsell quick-add fetch error:', err);
          })
          .finally(() => {
            triggerButton.classList.remove('loading');
            triggerButton.disabled = false;
          });
      }

      #processDeployerQuickAddContent(responseText, modalContent, productFullUrl, preferredVariantId) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseText, 'text/html');
        const productEl = doc.querySelector('.product');
        if (!productEl) {
          modalContent.innerHTML = '';
          return;
        }

        const section = productEl.closest('section');
        if (!section) {
          modalContent.innerHTML = '';
          return;
        }

        const removeSelectors = [
          '.product__block.product__accordion',
          'toggle-cross-sell',
          '.product_thumbnail-list',
          '.product__image-container',
          '.product__block.product__description',
          '.breadcrumb-wrapper',
          '.breadcrumb',
          'sticky-atc-button'
        ];
        removeSelectors.forEach((selector) => {
          section.querySelectorAll(selector).forEach((el) => el.remove());
        });

        /* Use innerHTML only: do not re-execute scripts from the product page (HTMLUpdateUtility
           would run them and cause "productId already declared" / ShopifyXR errors in the console). */
        modalContent.innerHTML = section.outerHTML;

        /* Mark modal form so we never mix it with the main page form (e.g. on product page). */
        const modalForm = modalContent.querySelector('form[data-product-form]');
        if (modalForm) modalForm.setAttribute('data-deployer-quick-add-form', 'true');

        /* Liquid rend toujours le bloc BIS ; on le cache tant que la sync variante n’a pas tranché. */
        modalContent.querySelectorAll('.block__back-in-stock-klaviyo, .klaviyo-bis-trigger, .wax-bis-trigger').forEach((el) => {
          if (el.style) el.style.display = 'none';
        });

        this.#scopeModalIds(modalContent);
        this.#preventModalInteractionWithPage(modalContent);
        const wrapper = modalContent.querySelector('.product-wrapper');
        if (wrapper) {
          wrapper.removeAttribute('data-enable-history-state');
          wrapper.setAttribute('data-deployer-quick-add-modal', 'true');
        }
        this.#setupModalVariantSync(modalContent, preferredVariantId);

        const productWrapper = modalContent.querySelector('.product-wrapper .product');
        if (productWrapper) {
          const link = document.createElement('a');
          link.href = productFullUrl;
          link.textContent = 'Voir le produit';
          link.classList.add('quick-add-popup-redirection');
          productWrapper.appendChild(link);
        }
      }

      #scopeModalIds(container) {
        const prefix = 'deployer-quick-add-' + Date.now() + '-';
        const idMap = new Map();
        /* Prefix every id so the modal has no duplicate IDs with the main page (avoids document.getElementById / querySelector picking the page element when on product page). */
        const elementsWithId = container.querySelectorAll('[id]');
        elementsWithId.forEach((el) => {
          const oldId = el.getAttribute('id');
          if (!oldId) return;
          const newId = prefix + oldId;
          idMap.set(oldId, newId);
          el.setAttribute('id', newId);
        });

        const updateRef = (el, attr) => {
          const val = el.getAttribute(attr);
          if (!val) return;
          const ids = val.split(/\s+/).map((id) => id.startsWith('#') ? id.slice(1) : id);
          const newIds = ids.map((id) => idMap.get(id) || id).join(' ');
          el.setAttribute(attr, newIds);
        };

        container.querySelectorAll('[for]').forEach((el) => {
          const oldFor = el.getAttribute('for');
          if (idMap.has(oldFor)) el.setAttribute('for', idMap.get(oldFor));
        });
        container.querySelectorAll('[aria-labelledby]').forEach((el) => updateRef(el, 'aria-labelledby'));
        container.querySelectorAll('[aria-describedby]').forEach((el) => updateRef(el, 'aria-describedby'));
        container.querySelectorAll('[aria-controls]').forEach((el) => updateRef(el, 'aria-controls'));

        container.querySelectorAll('a[href^="#"]').forEach((el) => {
          const href = el.getAttribute('href');
          const id = href.slice(1).split(/[?#]/)[0];
          if (idMap.has(id)) el.setAttribute('href', '#' + idMap.get(id));
        });

        const productWrapper = container.querySelector('.product-wrapper');
        if (productWrapper && productWrapper.hasAttribute('data-section-id')) {
          productWrapper.setAttribute('data-section-id', prefix.replace(/-$/, ''));
        }
      }

      #preventModalInteractionWithPage(modalContent) {
        modalContent.addEventListener('click', (e) => e.stopPropagation());
      }

      #setupModalVariantSync(modalContent, preferredVariantId) {
        let variants = [];
        const variantsScript = modalContent.querySelector('script[data-product-variants]');
        if (variantsScript?.textContent) {
          try {
            const parsed = JSON.parse(variantsScript.textContent.trim());
            if (Array.isArray(parsed)) variants = parsed;
          } catch {}
        }
        if (variants.length === 0) {
          const form = modalContent.querySelector('form[data-deployer-quick-add-form]') || modalContent.querySelector('form[data-product-form]');
          const handle = form?.dataset?.productHandle;
          if (handle && window.theme?.routes?.products) {
            fetch(`${window.theme.routes.products}/${encodeURIComponent(handle)}.js`)
              .then((r) => r.json())
              .then((data) => {
                if (data?.variants?.length) {
                  this.#setupModalVariantSyncWithVariants(modalContent, data.variants, preferredVariantId);
                }
              })
              .catch(() => {});
          }
          return;
        }
        this.#setupModalVariantSyncWithVariants(modalContent, variants, preferredVariantId);
      }

      #setupModalVariantSyncWithVariants(modalContent, variants, preferredVariantId) {
        if (!Array.isArray(variants) || variants.length === 0) return;
        const form = modalContent.querySelector('form[data-deployer-quick-add-form]') || modalContent.querySelector('form[data-product-form]');
        if (!form) return;
        const variantSelect = form.querySelector('select[name="id"], select[data-variant-select]');
        if (!variantSelect) return;

        const norm = (s) => (s == null || s === '') ? '' : String(s).trim().toLowerCase();
        const findVariantByOptions = (option1, option2, option3) => {
          const n1 = norm(option1);
          const n2 = norm(option2);
          const n3 = norm(option3);
          let found = variants.find((v) => {
            const o1 = norm(v.option1);
            const o2 = norm(v.option2);
            const o3 = norm(v.option3);
            return (n1 === '' || o1 === n1) && (n2 === '' || o2 === n2) && (n3 === '' || o3 === n3);
          });
          if (!found && n1 !== '') {
            found = variants.find((variant) => norm(variant.option1) === n1);
          }
          return found;
        };

        const setVariantSelect = (variantId) => {
          const idStr = String(variantId);
          const opt = variantSelect.querySelector(`option[value="${idStr}"]`);
          if (opt) {
            opt.selected = true;
            variantSelect.value = idStr;
          }
        };

        const syncOptionUiFromVariant = (variant) => {
          if (!variant) return;
          const optionValues = [variant.option1, variant.option2, variant.option3];
          modalContent.querySelectorAll('.product__variant-select').forEach((group, idx) => {
            const value = (optionValues[idx] || '').toString().trim();
            if (!value) return;
            const valueNorm = value.toLowerCase();

            group.querySelectorAll('.product__color-swatch, [data-product-swatch]').forEach((swatch) => {
              const label = (swatch.dataset.label || swatch.getAttribute('data-label') || '').toString().trim();
              swatch.classList.toggle('selected', label.toLowerCase() === valueNorm);
            });
            const labelEl = group.querySelector('[data-swatch-selected]');
            if (labelEl) labelEl.textContent = value;

            const sel = group.querySelector('select[name^="options"]');
            if (sel) {
              for (const opt of sel.options) {
                if ((opt.value || '').toString().trim().toLowerCase() === valueNorm) {
                  sel.value = opt.value;
                  break;
                }
              }
            }

            group.querySelectorAll('input[name^="options"]').forEach((radio) => {
              radio.checked = (radio.value || '').toString().trim().toLowerCase() === valueNorm;
            });
          });
        };

        const getVariantBySelect = () =>
          variants.find((v) => String(v.id) === String(variantSelect.value));

        /* ATC vs Back-in-stock: même logique que product-tile-quick-add / theme.classic.js.
           Sans ça les deux boutons restent visibles (Liquid rend le BIS sans condition stock). */
        const syncAtcBisVisibility = (variant) => {
          const root = modalContent.querySelector('.product-wrapper') || modalContent;
          const available = Boolean(variant?.available);
          const setD = (sel, disp) =>
            root.querySelectorAll(sel).forEach((el) => {
              if (el.style) el.style.display = disp;
            });

          if (available) {
            setD('[data-add-button]', '');
            setD('.block__back-in-stock-klaviyo', 'none');
            setD('.klaviyo-bis-trigger, .wax-bis-trigger', 'none');
          } else {
            setD('[data-add-button]', 'none');
            setD('.block__back-in-stock-klaviyo', 'block');
            setD('.klaviyo-bis-trigger, .wax-bis-trigger', 'flex');
          }

          const atcBtn = root.querySelector('[data-add-button]');
          const atcText = atcBtn?.querySelector('[data-add-button-text]');
          if (atcBtn && atcText) {
            const { langAvailable, langSoldOut } = atcBtn.dataset;
            if (available) {
              atcBtn.removeAttribute('disabled');
              const priceSpan = atcBtn.querySelector('[data-add-button-price]');
              if (langAvailable && priceSpan) {
                atcText.innerHTML = `${langAvailable}<span data-add-button-price>${priceSpan.innerHTML}</span>`;
              } else if (langAvailable) {
                atcText.textContent = langAvailable;
              }
            } else {
              atcBtn.setAttribute('disabled', 'disabled');
              if (langSoldOut) atcText.textContent = langSoldOut;
            }
          }

          root.querySelectorAll('.block__back-in-stock-klaviyo .wax-bis-trigger').forEach((el) => {
            el.removeAttribute('onclick');
            if (!variant?.id) {
              el.disabled = true;
              el.onclick = null;
              return;
            }
            el.disabled = false;
            /* Sync #wax-variants-select avant d’ouvrir, sinon Wax liste les OOS du produit de la page. */
            el.onclick = (e) => {
              e.preventDefault();
              e.stopPropagation();
              const current = getVariantBySelect() || variant;
              const id = Number(current?.id);
              if (Number.isNaN(id)) return;
              const waxModal = document.querySelector('[id^="wax-back-in-stock-modal"]');
              if (waxModal) waxModal.dataset.variantId = String(id);
              syncWaxVariantSelectForUpsell(variants, id);
              if (typeof window.waxOpenBackInStockModal === 'function') {
                window.waxOpenBackInStockModal(id);
              }
            };
          });
        };

        const refreshModalVariantUi = (variant) => {
          applyDeployerQuickAddVariantIndicators(form, variants);
          syncAtcBisVisibility(variant);
        };

        const getSelectedOptionsFromForm = () => {
          const options = { 1: null, 2: null, 3: null };
          modalContent.querySelectorAll('.product__variant-select').forEach((group, idx) => {
            const optionKeyEl = group.querySelector('[data-product-option]');
            const optionKey = optionKeyEl?.dataset?.productOption;
            /* Option 2/3 (forme, format) often have no data-product-option; use group index. */
            const posNum = optionKey ? (parseInt(optionKey.replace(/\D/g, ''), 10) || (idx + 1)) : (idx + 1);
            const selectedSwatch = group.querySelector('.product__color-swatch.selected');
            if (selectedSwatch?.dataset?.label) {
              options[posNum] = selectedSwatch.dataset.label.trim();
              return;
            }
            const sel = group.querySelector('select[name^="options"]');
            if (sel?.value) {
              options[posNum] = sel.value.trim();
              return;
            }
            const radio = group.querySelector('input[name^="options"]:checked');
            if (radio?.value) {
              options[posNum] = radio.value.trim();
            }
          });
          return options;
        };

        const syncVariantSelectFromSelection = () => {
          const opts = getSelectedOptionsFromForm();
          const o1 = opts[1] ?? null;
          const o2 = opts[2] ?? null;
          const o3 = opts[3] ?? null;
          const hasAny = [o1, o2, o3].some((v) => v != null && v !== '');
          if (!hasAny) return null;
          const variant = findVariantByOptions(o1, o2, o3);
          if (variant) setVariantSelect(variant.id);
          return variant || null;
        };

        const onSwatchClick = (e) => {
          const swatch = e.target.closest && e.target.closest('[data-product-swatch]');
          if (!swatch) return;
          if (swatch.classList.contains('selected')) {
            e.preventDefault();
            return;
          }
          const group = swatch.closest('[data-product-option]');
          if (!group) return;
          e.preventDefault();
          e.stopPropagation();
          const newValue = (swatch.dataset.label || swatch.getAttribute('data-label') || '').toString().trim();
          if (!newValue) return;
          const optionKey = (group.dataset.productOption || group.getAttribute('data-product-option') || '').toString();
          const posNum = parseInt(optionKey.replace(/\D/g, ''), 10) || 1;
          const selectInForm = form.querySelector('select[name="id"], select[data-variant-select]');
          if (!selectInForm) return;
          const currentVariantId = selectInForm.value;
          const currentVariant = variants.find((v) => String(v.id) === String(currentVariantId));
          const o1 = posNum === 1 ? newValue : (currentVariant?.option1 ?? null);
          const o2 = posNum === 2 ? newValue : (currentVariant?.option2 ?? null);
          const o3 = posNum === 3 ? newValue : (currentVariant?.option3 ?? null);
          const variant = findVariantByOptions(o1, o2, o3);
          if (variant) {
            const idStr = String(variant.id);
            const opt = selectInForm.querySelector(`option[value="${idStr}"]`);
            if (opt) {
              opt.selected = true;
              selectInForm.value = idStr;
            }
            group.querySelectorAll('.product__color-swatch').forEach((s) => s.classList.remove('selected'));
            swatch.classList.add('selected');
            const variantSelectGroup = group.closest('.product__variant-select');
            const labelEl = variantSelectGroup ? variantSelectGroup.querySelector('[data-swatch-selected]') : group.querySelector('[data-swatch-selected]');
            if (labelEl) labelEl.textContent = newValue;
            refreshModalVariantUi(variant);
          }
        };
        modalContent.addEventListener('click', onSwatchClick, true);

        /* When user changes option 2 or 3 (dropdown or radio: forme, format, etc.), sync the variant select so the correct variant is used on submit. */
        modalContent.addEventListener('change', (e) => {
          const el = e.target;
          if (!modalContent.contains(el)) return;
          const name = (el.getAttribute && el.getAttribute('name')) || '';
          if (!name.startsWith('options')) return;
          const variant = syncVariantSelectFromSelection();
          refreshModalVariantUi(variant || getVariantBySelect());
        });

        if (preferredVariantId) {
          const preferred = variants.find((v) => String(v.id) === String(preferredVariantId));
          if (preferred) {
            setVariantSelect(preferred.id);
            syncOptionUiFromVariant(preferred);
          }
        }

        refreshModalVariantUi(getVariantBySelect());

        form.addEventListener('submit', (e) => {
          if (!e.target.hasAttribute('data-deployer-quick-add-form') || !modalContent.contains(e.target)) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          syncVariantSelectFromSelection();
          const idFromForm = form.querySelector('select[name="id"], select[data-variant-select]');
          const variantId = idFromForm ? idFromForm.value : null;
          if (!variantId) return;
          const quantityInput = form.querySelector('input[name="quantity"]');
          const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
          const atcButton = form.querySelector('button[data-add-button], button[type="submit"]');
          if (atcButton) {
            atcButton.disabled = true;
            atcButton.classList.add('bttn--loading');
          }
          const body = new URLSearchParams();
          body.append('id', variantId);
          body.append('quantity', String(quantity));
          fetch((window.theme && window.theme.routes && window.theme.routes.root) ? `${window.theme.routes.root}cart/add.js` : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
            body: body.toString()
          })
            .then((r) => r.json())
            .then((res) => {
              if (res.status === 422) throw new Error(res.description || 'Unavailable');
              if (this.quickAddModal) quickAddModalClose(this.quickAddModal);
              document.dispatchEvent(new CustomEvent('deployer-cart-drawer:update-and-open'));
            })
            .catch((err) => console.error('Deployer upsell quick-add add to cart:', err))
            .finally(() => {
              if (atcButton) {
                atcButton.disabled = false;
                atcButton.classList.remove('bttn--loading');
              }
            });
        }, true);
      }

      async #handleAddToCart(button, card) {
        const variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        const buttonTextDesktop = button.querySelector('[data-button-text-desktop]');
        const buttonTextMobile = button.querySelector('[data-button-text-mobile]');
        const originalTextDesktop = buttonTextDesktop?.textContent;
        const originalTextMobile = buttonTextMobile?.textContent;

        button.disabled = true;
        button.classList.add('loading');
        if (buttonTextDesktop) buttonTextDesktop.textContent = this.addToCartTextDesktop;
        if (buttonTextMobile) buttonTextMobile.textContent = this.addToCartTextMobile;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }]
            })
          });

          const data = await response.json();

          if (!response.ok) {
            throw new Error(data.description || 'Erreur lors de l\'ajout au panier');
          }

          document.dispatchEvent(new CustomEvent('deployer-cart-drawer:update-and-open'));
        } catch (error) {
          if (buttonTextDesktop) buttonTextDesktop.textContent = originalTextDesktop;
          if (buttonTextMobile) buttonTextMobile.textContent = originalTextMobile;
          console.error('Deployer upsell add to cart:', error);
        } finally {
          button.disabled = false;
          if (buttonTextDesktop) buttonTextDesktop.textContent = originalTextDesktop;
          if (buttonTextMobile) buttonTextMobile.textContent = originalTextMobile;
          button.classList.remove('loading');
        }
      }
    }
  );
}
